exports.list = {
    path: '/laporan_inventory',
    name: 'laporan_inventory', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/laporan_inventory/List.vue"),
}